"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const regions = ["Auckland", "Wellington", "Christchurch", "Hamilton", "Tauranga"];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-primary-foreground/10 animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-secondary-foreground/70 hover:text-primary transition-colors duration-200 font-sans text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer data-section-id="161284" id="projectora-footer" className="dark bg-background">
      <div className="bg-secondary/30 text-secondary-foreground pt-16 pb-8 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
            
            {}
            <div className="md:col-span-4 flex flex-col items-start">
              <Link to="/HomePage" className="mb-6 inline-block">
                <img src="https://climbing-leech-1.10web.cloud/wp-content/uploads/2026/03/Screenshot-2026-03-23-at-7.18.58-PM.png" alt="Projectora Consulting Limited" className="h-7 w-auto" />
              </Link>
              <address className="not-italic text-secondary-foreground/80 leading-relaxed font-sans text-sm max-w-xs">133 Bayswater Avenue, Auckland Newzealand<br /><div className="mt-4 space-y-1"><Link to="mailto:info@projectora.nz" className="hover:text-primary transition-colors block">info@projectora.nz</Link><Link to="tel:+6402041310487" className="hover:text-primary transition-colors block">+64 20 413 10487</Link></div></address>
            </div>

            {}
            <div className="md:col-span-4">
              <h3 className="font-sans font-bold text-lg mb-6 tracking-tight text-foreground">
                Quick Links
              </h3>
              <MenuProvider menu_id="50">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>

            {}
            <div className="md:col-span-4">
              <h3 className="font-sans font-bold text-lg mb-6 tracking-tight text-foreground"><br /></h3>
              
            </div>
          </div>

          {}
          <Separator className="my-10 bg-border/40" />

          {}
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-muted-foreground">
            <p className="font-sans">
              &copy; {currentYear} Projectora Consulting Limited. Results-obsessed delivery. Site by Projectora.
            </p>
            <div className="flex items-center gap-4">
              <Link to="https://linkedin.com" newTab className="hover:text-primary transition-colors duration-200 p-2 -m-2" aria-label="Follow us on LinkedIn">
                <Linkedin className="size-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}